<template>
    <div class="header__wrapper">
        <header class="header">
            <div class="header__inner">
                <BurgerButton
                    :active-class="activeNavbar"
                    @click="toggleNavbar"
                />

                <h5 class="title header__title">
                    {{ $t('adminPanel') }}
                </h5>
            </div>

            <div class="header__inner">
                <LanguagesSelect v-if="!isSm" />

                <h6 class="title header__user-info uppercase-first-letter">
                    <span class="header__user-info-role">{{ role }}:</span>
                    <span class="header__user-info-name">{{ me?.login }}</span>
                </h6>

                <span class="header__divider" />

                <RowButton
                    class="logout-button"
                    icon="logout"
                    @click="emit('logout')"
                />
            </div>
        </header>
    </div>
</template>

<script>
export default {
    name: 'HeaderSection',
};
</script>

<script setup>
import { inject, defineEmits, ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RowButton from '@/components/ui/buttons/RowButton';
import LanguagesSelect from '@/components/ui/LanguagesSelect/index.vue';
import BurgerButton from '@/components/ui/buttons/BurgerButton';

const { t } = useI18n();
const { me } = inject('me');

const emit = defineEmits(['logout']);
const emitter = inject('emitter');
const activeNavbar = ref(false);
const isSm = inject('isSm');
const role = computed(() => t(`role.${me.role}`));

const toggleNavbar = () => {
    activeNavbar.value = !activeNavbar.value;
    emitter.emit('toggle-navbar');
};

const onClickNavbarItem = ({ force } = {}) => {
    activeNavbar.value = false;
};

onMounted(() => {
    emitter.on('click-navbar-item', onClickNavbarItem);
});

onBeforeUnmount(() => {
    emitter.off('click-navbar-item');
});
</script>

<style src="./styles.scss" lang="scss" scoped />
